import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Database types based on your schema
export interface Athlete {
  athraceno: number
  athname: string | null
  createdat: string
  createdby: string | null
}

export interface Location {
  locationid: number
  locationname: string | null
  penaltytime: number | null
}

export interface RaceOfficial {
  officialid: number
  officialuuid: string | null
  email: string
  firstname: string | null
  lastname: string | null
  displayname: string | null
  roleid: number | null
  phonenumber: number | null
  isactive: boolean
  supervisorid: number | null
  lastlogin: string | null
  notes: string | null
  judgestation: number | null
  registeredevents: number[] | null
  currenteventid: number | null
  createdat: string
  createdby: string | null
}

export interface RaceRole {
  roleid: number
  rolename: string
  roledescription: string | null
  permissions: Record<string, any> | null
  isactive: boolean
  createdat: string
  createdby: string | null
  updatedat: string | null
  updatedby: string | null
}

export interface PenaltyLedger {
  eventid: number
  createdat: string
  locationid: number | null
  athraceno: number | null
  penaltytime: number | null
  racejudgemail: string | null
  judgename: string | null
  raceoffroleid: number | null
  numpenalties: number | null
  athracephotourl: string | null
  notes: string | null
  status: string | null
}

export interface HyRaceEvent {
  eventid: number
  eventname: string
  eventdescription: string | null
  eventdate: string
  eventlocation: string | null
  eventstatus: string | null
  maxparticipants: number | null
  registrationstart: string | null
  registrationend: string | null
  eventstarttime: string | null
  eventendtime: string | null
  isactive: boolean
  createdat: string
  createdby: string | null
  updatedat: string | null
  updatedby: string | null
}